import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDefaultRooftopQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetDefaultRooftopQuery = { __typename?: 'query_root', customers_by_pk?: { __typename?: 'customers', id: number, name?: string | null, category?: string | null, config?: object | null, effective_config?: object | null, tier: string, location?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null, timezone?: string | null, region_id?: number | null, region?: { __typename?: 'regions', id: number, name: string, status: string } | null } | null, organization?: { __typename?: 'organizations', id: number, name: string, config?: object | null } | null } | null };


export const GetDefaultRooftopDocument = gql`
    query getDefaultRooftop($customerId: bigint!) {
  customers_by_pk(id: $customerId) {
    id
    name
    category
    config
    effective_config
    tier
    location {
      id
      name
      address
      latitude
      longitude
      timezone
      region_id
      region {
        id
        name
        status
      }
    }
    organization {
      id
      name
      config
    }
  }
}
    `;

/**
 * __useGetDefaultRooftopQuery__
 *
 * To run a query within a React component, call `useGetDefaultRooftopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultRooftopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultRooftopQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetDefaultRooftopQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables> & ({ variables: GetDefaultRooftopQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>(GetDefaultRooftopDocument, options);
      }
export function useGetDefaultRooftopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>(GetDefaultRooftopDocument, options);
        }
// @ts-ignore
export function useGetDefaultRooftopSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>;
export function useGetDefaultRooftopSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefaultRooftopQuery | undefined, GetDefaultRooftopQueryVariables>;
export function useGetDefaultRooftopSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>(GetDefaultRooftopDocument, options);
        }
export type GetDefaultRooftopQueryHookResult = ReturnType<typeof useGetDefaultRooftopQuery>;
export type GetDefaultRooftopLazyQueryHookResult = ReturnType<typeof useGetDefaultRooftopLazyQuery>;
export type GetDefaultRooftopSuspenseQueryHookResult = ReturnType<typeof useGetDefaultRooftopSuspenseQuery>;
export type GetDefaultRooftopQueryResult = Apollo.QueryResult<GetDefaultRooftopQuery, GetDefaultRooftopQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/layout/queries/getDefaultRooftop.query.gql}
 */
export async function getDefaultRooftop(
  variables: GetDefaultRooftopQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDefaultRooftopQuery['customers_by_pk']>
export async function getDefaultRooftop(
  variables: GetDefaultRooftopQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDefaultRooftopQuery>
export async function getDefaultRooftop(
  variables: GetDefaultRooftopQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDefaultRooftopQuery['customers_by_pk'] | GetDefaultRooftopQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDefaultRooftopQuery>(
    GetDefaultRooftopDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers_by_pk
}